import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div`
  ${flexStyle({ direction: 'column' })}
  gap: 4px;
  padding: 10px 12px;
  border-radius: 6px;
  border-left: 3px solid ${({ theme }) => theme.colors.warning};
  background: ${({ theme }) => theme.colors.secondaryBackground};
`;

export const Summary = styled.div`
  ${textStyle({ weight: 500, size: '12px' })}
  color: ${({ theme }) => theme.colors.warning};
`;

export const List = styled.ul`
  ${flexStyle({ direction: 'column' })}
  gap: 3px;
  margin: 2px 0 0;
  padding-left: 16px;
`;

export const Item = styled.li`
  ${textStyle({ weight: 400, size: '12px', color: 'textSecondary' })}
`;

export const ToggleButton = styled.button`
  ${textStyle({ weight: 500, size: '12px', color: 'linkBlue' })}
  align-self: flex-start;
  padding: 2px 0;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
